import React from 'react';
import { useNavigate } from 'react-router-dom';
import CustomButton from './CustomButton';
import { useTranslation } from 'react-i18next';

const Error404 = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const topBackClick = () => {
    navigate('/collection-day');
  };
  return (
    <div>
      <div className="container-xxl">
        {/* <div className="govuk-error-summary" data-module="govuk-error-summary">
          <div role="alert">
            <h2 className="govuk-error-summary__title">Page not found</h2>
            <div className="govuk-error-summary__body">
              <ul className="govuk-list govuk-error-summary__list">
                <li>
                  <a href="/">If you typed the web address, check it is correct.</a>
                </li>
                <li>
                  <a href="/ ">If you pasted the web address, check you copied the entire address.</a>
                </li>
              </ul>
            </div>
          </div>
        </div> */}
        <div className="me-2" style={{ color: '#1F70B8', fontSize: '20px' }}>
          {`< `}
          <CustomButton onClick={topBackClick} disable={false}>
            {` ${t('back')}`}
          </CustomButton>
        </div>
        <div className="govuk-grid-row">
          <div className="govuk-grid-column-two-thirds">
            <h1 className="govuk-heading-l">Page not found</h1>
            <p className="govuk-body">If you typed the web address, check it is correct.</p>
            <p className="govuk-body">If you pasted the web address, check you copied the entire address.</p>
            <p className="govuk-body">If the web address is correct or you selected a link or button, contact us if you need to speak to someone.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error404;
